import React, { Component } from 'react';
import { connect } from 'react-redux';

import { addExportAirwayBillPartToCart } from '../../../store/actions/truckCartAction';

import Awb from '../../../models/Awb';
import AwbPart, { AwbPartStatuses } from '../../../models/AwbPart';
import TruckCartItem, { TruckCartItemPart } from '../../../models/TruckCartItem';
import ApiResponse from '../../../models/ApiResponse';

import AddAWBModal from './AddAWBModal';

import { AWB_SCHEMA } from '../../../utils/airwayBill';
import Moment from 'moment';
import { getAwbPartStatuses } from '../../../store/actions/awbPartStatusesAction';
import User, { UserRoleType } from '../../../models/User';
import userManagementReqHandler from '../../../api/userManagementRemote';
import AirlineType from '../../../models/AirlineType';
import ResponseError from '../../../models/ResponseError';
import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';

const shipperProfileOptions: Array<string> = ['-- Define shipper profile', 'Known', 'Unknown'];
const ccsfOptions: Array<string> = ['', 'Yes', 'No'];

interface AddAWBModalContainerState {
  awb: Awb;
  edited: boolean;
  errorMsg: {
    pieces: string;
    weight: string;
    add: string;
  },
  checkClose: boolean;
  errorClose: string;
  validation: boolean;
  shipperProfileError: boolean;
  ccsf: { ccsfDisabled: boolean; ccsfIndex: number; ccsfError: boolean; };
  valueFirstFlightOut: string;
  firstFlightOutPossible: Array<string>;
  metadata: boolean;
  edit: boolean;
  airlines: AirlineType[];
  disableUpdate: boolean;
};

interface AddAWBModalContainerProps {
  userRole: UserRoleType;
  classes?: any;
  modalOpen: boolean;
  awb: Awb;
  handleSave: Function;
  handleSync?: Function;
  receiveSuccess: Function;
  awbInfo?: boolean;
  receiveError: Function;
  handleCloseModal: Function;
  addExportAirwayBillPartToCart: Function;
  getAvailableAwbPartStatuses: Function;
  truckCart: Array<TruckCartItem>;
  awbActionOfUpdateButton: 'add' | 'update';
  availableAwbPartStatuses: AwbPartStatuses;
  edited: boolean,
  manualEntry?: boolean;
  user: User;
  clearAwb?: () => void; 
};

class AddAWBModalContainer extends Component<AddAWBModalContainerProps, AddAWBModalContainerState> { 

  state = {
    awb: AWB_SCHEMA,
    edited: false,
    errorMsg: {
      pieces: '',
      weight: '',
      add: ''
    },
    checkClose: true,
    errorClose: '',
    validation: false,
    shipperProfileError: false,
    ccsf: {
      ccsfDisabled: false,
      ccsfIndex: 0,
      ccsfError: false
    },
    valueFirstFlightOut: '',
    firstFlightOutPossible: [''],
    metadata: true,
    edit: false,
    airlines: [] as AirlineType[],
    disableUpdate: false,
  };

  componentDidMount() {

    const awb: Awb = { ...this.props.awb };
    const metadata: boolean = !this.props.awb.edited;
    const edited: boolean = this.props.edited;
    const ccsf: { ccsfDisabled: boolean; ccsfIndex: number; ccsfError: boolean; } = {
      ccsfDisabled: false,
      ccsfIndex: 0,
      ccsfError: false
    };

    if(awb.export_parts.length === 0) {
      awb.export_parts.push({
        id: '',
        arrival_date: '',
        flight_date: '',
        delivered: false,
        pieces: 0,
        received: false,
        tableData: { id: 0 },
        weight: '',
        flight_no: '',
        number: '',
        flight: '',
        status: '',
        not_delivered_pieces: 0,
        not_delivered_weight: 0
      });
    } else {
      awb.export_parts.forEach(element => {
        element.flight = element.flight_no ? element.flight_no.substring(0, 2) : '';
        element.number = element.flight_no ? element.flight_no.substring(2) : '';
      });
    }
    this.handleDefineFirstFlightOutOptions(awb.export_parts)
    const valueFirstFlightOut: string = this.props.awb.export_metadata.firstFlightNumber + ' - ' + Moment(this.props.awb.export_metadata.firstFlightDate).format('DD MMM YYYY')
  
    if (awb.export_metadata.shipperProfile === shipperProfileOptions[2]) {
      ccsf.ccsfIndex = 2;
      ccsf.ccsfDisabled = true;
    }

    if (awb.export_metadata.shipperProfile === shipperProfileOptions[1]) {
      ccsf.ccsfIndex = awb.export_metadata.ccsf === true ? 1 : 2;
      ccsf.ccsfDisabled = false;
    }

    if(this.props.availableAwbPartStatuses.import.length === 0) {
      this.props.getAvailableAwbPartStatuses();
    }

    this.setState({ awb, ccsf, valueFirstFlightOut, metadata, edited }, async() => {
      await this.onValidationPcs();
      await this.onValidationWgt();
    });
    if(this.props.userRole !== 'fwd')
      this.getGhaAirlines();
  };

  onValidationPcs = (): void => { 

    let totalPcs: number = +this.state.awb.pieces;
    let sum: number = this.state.awb.export_parts.reduce((total, part) => { 
       return (total + +(part.pieces));
    }, 0);

    if (totalPcs !== sum) {
      this.setState({
        errorMsg: {
        ...this.state.errorMsg,
        pieces: 'Тhe total number of pieces does not match the sum of the pieces in the parts!'
        },
        validation: true
      });
    } else {
      this.setState({
        errorMsg: {
          ...this.state.errorMsg,
          pieces: ''
        },
        validation: false
      });
    }
  };
  
  onValidationWgt = (): void => { 
    
    let totalWeight: number = +(this.state.awb.weight);
    let sum: number = this.state.awb.export_parts.reduce((total, part) => { 
      return (total + +(part.weight));
    }, 0);
  
    if (totalWeight !== sum) {
      this.setState({
        errorMsg: {
           ...this.state.errorMsg,
          weight: 'The total weight is not equal to the sum of the weights of the parts!'
        },
        validation: true
      });
    } else {
      this.setState({
        errorMsg: { ...this.state.errorMsg, weight: '' },
        validation: false
      });
    };
  };

  handleChange = (propertyName: string, event: any): any => {

    const value = event.target.value;
 
    const ccsf: { ccsfDisabled: boolean; ccsfIndex: number; ccsfError: boolean; } = { ...this.state.ccsf }; 
    let awb: Awb = { ...this.state.awb };
    let edited: boolean = this.state.edited;
    let metadata: boolean = this.state.metadata;
    let valueFirstFlightOut: string = this.state.valueFirstFlightOut;
    let shipperProfileError: boolean = this.state.shipperProfileError;
    let edit: boolean = this.state.edit;

    switch (propertyName) {
        case 'pieces':
          awb.pieces = value.toUpperCase();
          edited = true;
          metadata = false;
          edit = true;
          break;
        case 'weight':
          awb.weight = value.toUpperCase();
          edited = true;
          metadata = false;
          edit = true;
          break;
        case 'origin':
          awb.origin = value.toUpperCase().trim().substr(0, 3);
          edited = true;
          metadata = false;
          edit = true;
          break;
        case 'destination':
          awb.destination = value.toUpperCase().trim().substr(0, 3);
          edited = true;
          metadata = false;
          edit = true;
          break;
      
        case 'firstFlightOut':
          valueFirstFlightOut = value;
          const [firstFlightNumber, flightDate ] = valueFirstFlightOut.split('-');
          const firstFlightDate: string = Moment(flightDate).format('YYYYMMDD');
          awb.export_metadata.firstFlightDate = firstFlightDate.trim();
          awb.export_metadata.firstFlightNumber = firstFlightNumber.trim();
          edited = true;

          break;

        case 'shipperName': awb.export_metadata.shipperName = value, edited = true; break;
       
        case 'commodity': awb.export_metadata.comodityType = value; edited = true; break;
       
        default: return;
    }

    this.setState({ awb, ccsf, shipperProfileError, edited, valueFirstFlightOut, metadata, edit });
  };

  handleClose = (): void => {

    if(this.state.checkClose && this.state.edited) {

      this.setState({
        checkClose: false,
        errorClose: 'Your updates will be lost. If you want to keep changes, select "Update", if you want to exit without saving, select "X"'
      });
    } else {

      this.setState({ checkClose: true, errorClose: '', edited: false });
      this.props.handleCloseModal();
    };
  };

  enableCartIcon = (awbPart: AwbPart): boolean => {

    const foundCart: TruckCartItem | undefined = this.findInCart(this.state.awb.code, this.state.awb.number);
    let enable: boolean = true;

    if (foundCart) {

      const parts: Array<TruckCartItemPart> = foundCart.parts;

      for (const part of parts) {

        if (part.id === awbPart.id) {
          enable = false;
          break;
        };
      };
    };

    return enable;
  };

  findInCart = (code: string, number: string): TruckCartItem | undefined => {

    return this.props.truckCart.find((cartElement: TruckCartItem) => {
      return cartElement.code === code && cartElement.number === number;
    });
  };

  addPartToCart = (awbPart: AwbPart): void => {
    
    this.props.addExportAirwayBillPartToCart(this.state.awb.code, this.state.awb.number, awbPart.id);
  };

  setContainerState = (data: any): void => {
    const { awb } = data;
    if (awb) {

      this.handleDefineFirstFlightOutOptions(awb.export_parts);

      if (this.state.firstFlightOutPossible[0] && this.state.firstFlightOutPossible.indexOf(this.state.valueFirstFlightOut) < 0) {

        const [firstFlightNumber, flightDate ] = this.state.firstFlightOutPossible[0].split('-');
        const firstFlightDate: string = Moment(flightDate).format('YYYYMMDD');
        awb.export_metadata.firstFlightDate = firstFlightDate.trim();
        awb.export_metadata.firstFlightNumber = firstFlightNumber.trim(); 

        this.setState({ valueFirstFlightOut: this.state.firstFlightOutPossible[0]});
         
      }
      if (this.props.manualEntry) {
        let sumPcs: number = awb.export_parts.reduce((total: any, part: any) => { 
          return (total + +(part.pieces));
        }, 0);
        let sumWgt: number = awb.export_parts.reduce((total: any, part: any) => { 
          return (total + +(part.weight));
        }, 0);
        awb.pieces = sumPcs;
        awb.weight = sumWgt;
      }
      this.setState({ awb,  edited: true, edit: true });

    } else {
      this.setState(data);
    } 
  };

  getGhaAirlines = () => {
    userManagementReqHandler.getAirlines().then(resp => {
      const airlines: Array<AirlineType> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }

      if(airlines) {
        this.setState({ airlines: airlines });
      }
    })
  }

  handleValidationBeforeSave = (): void => {

    const awb: Awb = { ...this.state.awb };
    let isValid: boolean = true;
    
    if (!awb.export_metadata.firstFlightNumber || !awb.export_metadata.firstFlightDate) {
      return;
    }

    if (isValid) {
      const opt = { edit: this.state.edit, metadata: false }
      if(this.props.clearAwb) {
        this.props.clearAwb();
      }
      this.setState({ disableUpdate: true });
      const res = this.props.handleSave(this.state.awb, opt);
      if (res && res.then) {
        res.then(() => this.setState({ disableUpdate: false }))
           .catch(() => this.setState({ disableUpdate: false }));
      }
      return res;
    }
  }

  handleDefineFirstFlightOutOptions = (parts: Array<AwbPart>): void => {

    let result: Array<string> = [];
    let firstFlightDate: string = parts[0] ? parts[0].flight_date: '';

    for (let part of parts) {

      if (firstFlightDate < part.flight_date) {
        continue;
      };

      if (firstFlightDate > part.flight_date) {
        result = [];
        firstFlightDate = part.flight_date
      }

      const option: string = part.flight_no + ' - ' + Moment(part.flight_date).format('DD MMM YYYY');
      result.push(option);
    }
    
   this.setState({firstFlightOutPossible: result});
  }

  render() {
    const manager = this.props.user.roleName === 'GHA Manager' || this.props.user.roleName === 'GHA Supervisor';
    
    return (
      <AddAWBModal
        errorMsg={ this.state.errorMsg }
        awb={ this.state.awb }
        edited={ this.state.edited }
        handleChange={ this.handleChange }
        availableAwbPartStatusesForProcess={ this.props.availableAwbPartStatuses.export }
        onValidationPcs={ this.onValidationPcs }
        onValidationWgt={ this.onValidationWgt }
        handleClose={ this.handleClose }
        handleSync={ this.props.handleSync }
        modalOpen={ this.props.modalOpen }
        setState={ this.setContainerState }
        enableCartIcon={ this.enableCartIcon }
        addPartToCart={ this.addPartToCart }
        handleValidationBeforeSave={ this.handleValidationBeforeSave }
        errorClose={ this.state.errorClose }
        shipperProfileOptions={ shipperProfileOptions }
        shipperProfileError={ this.state.shipperProfileError }
        ccsfOptions={ ccsfOptions }
        ccsf={ this.state.ccsf }
        awbActionOfUpdateButton={ this.props.awbActionOfUpdateButton }
        valueFirstFlightOut={ this.state.valueFirstFlightOut }
        firstFlightOutPossible={ this.state.firstFlightOutPossible }
        manualEntry={ this.props.manualEntry}
        userRole={ this.props.userRole }
        airlines={ this.state.airlines }
        awbInfo={ this.props.awbInfo }
        managerAccess={manager}
        disableUpdate={ this.state.disableUpdate }
      />
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
    truckCart: state.truckCart.cart,
    availableAwbPartStatuses: state.awbPartStatuses,
    user: state.user
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getAvailableAwbPartStatuses: () => dispatch(getAwbPartStatuses()),
    addExportAirwayBillPartToCart: (code: string, number: string, partId: string) => dispatch(addExportAirwayBillPartToCart(code, number, partId)),
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (msg: string) => dispatch(receiveSuccess(msg))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAWBModalContainer);